import React from "react";

import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";

import AccessTimeIcon from "@material-ui/icons/AccessTime";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import ThriveSignaturegep from 'assets/img/Thrive Signaturegep.png';
import landinglogo from 'assets/img/hs_landing.png';
import bannerImage from 'assets/img/landingbanner.png';



export default function ThriveSignatureInProgress({setNext,
  signatureData,}) {

    console.log(signatureData,"1002604")
  const enrollmentData = {
  practiceName:
    signatureData?.practice_name ||
    signatureData?.practiceName ||
    "",

  practiceOwner:
    `${signatureData?.ownerfirstname || ""} ${
      signatureData?.ownerlastname || ""
    }`.trim(),

  locationAccountNumber:
    signatureData?.locationAccountNumber ||
    signatureData?.location_account_number ||
    signatureData?.shipto ||
    "",

  subscriptionPlan: signatureData?.plan
    ? `${signatureData.plan} Plan`
    : "",

  price:
    signatureData?.plan === "Monthly"
      ? "$115 per month"
      : signatureData?.plan === "Yearly"
      ? "$1,299 per year"
      : "",

  submitted: signatureData?.submiteddate
    ? new Date(signatureData.submiteddate).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : "",

  pointOfContact: {
    name:
      `${signatureData?.contactfirstname || ""} ${
        signatureData?.contactlastname || ""
      }`.trim(),
    email: signatureData?.customeremail || "",
  },

  status: "Pending Approval",

  supportEmail: "Thrive.Support@HenrySchein.com",
};

  const handleCheckDifferentAccount = () => {
    setNext('')
  };

  return (
    <>
      <style>{inProgressCss}</style>

      <div className="ip-page">

        {/* =====================================================
            TOP BANNER
        ===================================================== */}
        <div className="top-banner">
           <img
                      src={bannerImage}
                      alt="Thrive Signature"
                      className="top-banner-image"
                    />
          <div className="ip-banner-content">

            <div className="ip-brand">
              <img
                src={landinglogo}
                alt="Henry Schein"
                className="ip-hs-logo"
              />

              {/* <img
                src={sidelogo}
                alt="Thrive"
                className="ip-thrive-logo"
              /> */}
            </div>

            <div className="ip-brand-divider" />

            <div className="ip-tagline">
              Save More. Do More. <span>Thrive.</span>
            </div>

          </div>
        </div>

        {/* =====================================================
            FULL OUTER CARD
        ===================================================== */}
        <div className="ip-card-container">

          {/* ===================================================
              TITLE
          =================================================== */}
          <h1 className="ip-title">
            Thrive Signature Enrollment Status
          </h1>

          {/* ===================================================
              STATUS CARD
          =================================================== */}
          <div className="ip-card">

            {/* BRAND */}
            <div className="ip-card-brand">

              <img
                src={ThriveSignaturegep}
                alt="Henry Schein"
              />

              {/* <div className="ip-card-thrive">
                thrive
                <span>Signature</span>
              </div> */}

            </div>

            {/* CLOCK ICON */}
            <div className="ip-icon-outer">
              <div className="ip-icon-inner">
                <AccessTimeIcon />
              </div>
            </div>

            {/* HEADING */}
            <h2 className="ip-heading">
              In Progress
            </h2>

            {/* DESCRIPTION */}
            <p className="ip-text">
              Your Thrive Signature enrollment has already been{" "}
              <br className="desktop-break" />
              submitted and is currently being processed.{" "}
              <br className="desktop-break" />
              No additional action is needed at this time.
            </p>

            <div className="ip-divider" />

            {/* =================================================
                ENROLLMENT DETAILS
            ================================================= */}
            <div className="ip-details-section">

              <h3>
                Enrollment Details
              </h3>

              <DetailRow
                label="Practice Name:"
                value={enrollmentData.practiceName}
              />

              <DetailRow
                label="Location Account Number:"
                value={enrollmentData.locationAccountNumber}
              />

              <div className="ip-row">

                <div className="ip-row-label">
                  Subscription Plan:
                </div>

                <div className="ip-row-value">
                  <div>
                    {enrollmentData.subscriptionPlan}
                  </div>

                  <div className="ip-row-muted">
                    {enrollmentData.price}
                  </div>
                </div>

              </div>

              <DetailRow
                label="Submitted:"
                value={enrollmentData.submitted}
              />

              <div className="ip-row">

                <div className="ip-row-label">
                  Point of Contact:
                </div>

                <div className="ip-row-value">

                  <div>
                    {enrollmentData.pointOfContact.name}
                  </div>

                  <div className="ip-row-muted" style={{overflowWrap: "anywhere"}}>
                    {enrollmentData.pointOfContact.email}
                  </div>

                </div>

              </div>

              <div className="ip-row ip-row-last">

                <div className="ip-row-label">
                  Status:
                </div>

                <div className="ip-row-value">

                  <span className="ip-status-badge">
                    <span className="ip-status-dot" />
                    {enrollmentData.status}
                  </span>

                </div>

              </div>

            </div>

            <div className="ip-divider" />

            {/* =================================================
                WHAT HAPPENS NEXT
            ================================================= */}
            <div className="ip-next-section">

              <h3>
                What happens next?
              </h3>

              <p>
                We'll send an email once your Thrive Signature
                enrollment{" "}
                <br className="desktop-break" />
                has been completed and your membership is ready.
              </p>

            </div>

            {/* BUTTON */}
            <button
              type="button"
              className="ip-button"
              onClick={handleCheckDifferentAccount}
            >
              Check a Different Account Number
            </button>

          </div>

          {/* ===================================================
              THREE CONTENT ITEMS
          =================================================== */}
          <div className="ip-strip">

            {/* ITEM 1 */}
            <StripItem
              icon={<StarBorderIcon />}
              title="Your Thrive Rewards membership stays active"
            >
              Your existing Thrive Rewards{' '}
              <br className="desktop-break" />
              membership remains active while{' '}
              <br className="desktop-break" />
              your Signature enrollment is being{' '}
              <br className="desktop-break" />
              processed.
            </StripItem>

            <div className="ip-strip-line" />

            {/* ITEM 2 */}
            <StripItem
              icon={<HelpOutlineIcon />}
              title="Questions?"
            >
              Contact your Henry Schein Sales{' '}
              <br className="desktop-break" />
              Consultant or{' '}
              <br className="desktop-break" />

              <a
                href={`mailto:${enrollmentData.supportEmail}`}
              >
                {enrollmentData.supportEmail}
              </a>
              .
            </StripItem>

            <div className="ip-strip-line" />

            {/* ITEM 3 */}
            <StripItem
              icon={<LockOutlinedIcon />}
              title="Secure Enrollment"
            >
              Your information is protected.
            </StripItem>

          </div>

        </div>
      </div>
    </>
  );
}

/* =========================================================
   DETAIL ROW
========================================================= */

const DetailRow = ({ label, value }) => {
  return (
    <div className="ip-row">

      <div className="ip-row-label">
        {label}
      </div>

      <div className="ip-row-value">
        {value}
      </div>

    </div>
  );
};

/* =========================================================
   BOTTOM STRIP ITEM
========================================================= */

const StripItem = ({
  icon,
  title,
  children,
}) => {
  return (
    <div className="ip-strip-item">

      <div className="ip-strip-icon">
        {icon}
      </div>

      <div className="ip-strip-text">

        <div className="ip-strip-title">
          {title}
        </div>

        <div className="ip-strip-description">
          {children}
        </div>

      </div>

    </div>
  );
};

/* =========================================================
   CSS
========================================================= */

const inProgressCss = `

* {
  box-sizing: border-box;
}

/* =========================================================
   PAGE
========================================================= */

.ip-page {
  width: 100%;
  min-height: 100vh;

  margin: 0;
  padding: 0 0 24px;

  background: #ffffff;

  font-family: Arial, Helvetica, sans-serif;

  color: #1638ca;

  overflow-x: hidden;
}

/* =========================================================
   TOP BANNER
========================================================= */

// .ip-banner {
//   width: 100%;
//   height: 120px;

//   position: relative;

//   overflow: hidden;

//   background:
//     linear-gradient(
//       135deg,
//       #e3f6ff 0%,
//       #d1edfc 20%,
//       #edfaff 42%,
//       #ccecff 65%,
//       #e7f7ff 100%
//     );
// }

// .ip-banner::before {
//   content: "";

//   position: absolute;

//   left: -30px;
//   top: -60px;

//   width: 220px;
//   height: 190px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(82,174,241,0.30) 46%,
//       rgba(82,174,241,0.30) 65%,
//       transparent 66%
//     );
// }

// .ip-banner::after {
//   content: "";

//   position: absolute;

//   right: 30px;
//   top: -70px;

//   width: 260px;
//   height: 200px;

//   background:
//     linear-gradient(
//       135deg,
//       transparent 45%,
//       rgba(75,166,231,0.20) 46%,
//       rgba(75,166,231,0.20) 65%,
//       transparent 66%
//     );
// }

.top-banner {
  width: 100%;
  height: 110px;
  position: relative;
  overflow: hidden;
  background: none;
}

.top-banner-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.banner-inner {
  position: relative;
  z-index: 2;
  /* existing styles */
}

/* =========================================================
   BANNER CONTENT
========================================================= */

.ip-banner-content {
  width: 100%;
  max-width: 720px;

  height: 100px;

  margin: 0 auto;

  padding: 10px 20px;

  position: relative;

  z-index: 2;

  display: flex;

  align-items: center;

  gap: 14px;
}

/* =========================================================
   BRAND
========================================================= */

.ip-brand {
  display: flex;

  flex-direction: column;

  align-items: flex-start;

  flex-shrink: 0;
}

.ip-hs-logo {
  width: 106px;

  height: auto;

  object-fit: contain;
}

.ip-thrive-logo {
  width: 110px;

  height: auto;

  margin-top: -2px;

  object-fit: contain;
}

.ip-brand-divider {
  width: 1px;

  height: 44px;

  background: #6f8fb8;

  flex-shrink: 0;
}

.ip-tagline {
  color: #103cd2;

  font-size: 18px;

  line-height: 22px;

  font-weight: 700;

  white-space: nowrap;
}

.ip-tagline span {
  color: #2f9be8;
}

/* =========================================================
   FULL OUTER CARD
========================================================= */

.ip-card-container {
  width: calc(100% - 28px);

  max-width: 720px;

  margin: -30px auto 0;

  padding: 24px 24px 30px;

  position: relative;

  z-index: 5;

  background: rgba(255,255,255,0.98);

  border: 1px solid #dceaf8;

  border-radius: 5px;

  box-shadow:
    0 5px 20px rgba(28,119,206,0.15);
}

/* =========================================================
   TITLE
========================================================= */

.ip-title {
  margin: 0 0 20px;

  text-align: center;

  color: #1026c9;

  font-size: 28px;

  line-height: 34px;

  font-weight: 700;
}

/* =========================================================
   INNER STATUS CARD
========================================================= */

.ip-card {
  width: 100%;

  max-width: 370px;

  margin: 0 auto;

  padding: 18px 20px 20px;

  border: 1.5px solid #4da6f0;

  border-radius: 5px;

  background: #ffffff;

  box-shadow:
    0 3px 12px rgba(45,130,220,0.12);

  text-align: center;

  overflow: hidden;
}

/* =========================================================
   CARD BRAND
========================================================= */

.ip-card-brand {
  display: flex;

  flex-direction: column;

  align-items: center;

  margin-bottom: 14px;
}

.ip-card-brand img {
  width: 140px;

  height: auto;

  object-fit: contain;
}

.ip-card-thrive {
  margin-top: -2px;

  color: #0785ed;

  font-size: 44px;

  line-height: 42px;

  font-weight: 700;

  letter-spacing: -2px;

  text-align: right;
}

.ip-card-thrive span {
  display: block;

  margin-top: 1px;

  color: #1473db;

  font-size: 11px;

  line-height: 12px;

  letter-spacing: 0;

  font-weight: 400;

  text-align: right;
}

/* =========================================================
   CLOCK ICON
========================================================= */

.ip-icon-outer {
  width: 64px;
  height: 64px;

  margin: 0 auto 10px;

  border-radius: 50%;

  display: flex;

  align-items: center;
  justify-content: center;

  background: #e3eeff;
}

.ip-icon-inner {
  width: 44px;
  height: 44px;

  display: flex;

  align-items: center;
  justify-content: center;

  color: #1966e6;
}

.ip-icon-inner svg {
  width: 42px;
  height: 42px;
}

/* =========================================================
   HEADING
========================================================= */

.ip-heading {
  margin: 0 0 10px;

  color: #1026c9;

  font-size: 24px;

  line-height: 28px;

  font-weight: 700;
}

.ip-text {
  margin: 0;

  color: #5f76b8;

  font-size: 11px;

  line-height: 16px;

  font-weight: 400;
}

/* =========================================================
   DIVIDER
========================================================= */

.ip-divider {
  width: 100%;

  height: 1px;

  margin: 14px 0 12px;

  background: #dbe5f3;
}

/* =========================================================
   DETAILS
========================================================= */

.ip-details-section {
  width: 100%;

  text-align: left;

  margin-bottom: 16px;
}

.ip-details-section h3 {
  margin: 0 0 8px;

  color: #102bc9;

  font-size: 15px;

  line-height: 19px;

  font-weight: 700;
}

.ip-row {
  width: 100%;

  display: grid;

  grid-template-columns: 135px 1fr;

  column-gap: 8px;

  padding: 7px 0;

  align-items: center;

  border-bottom: 1px solid #e1e9f4;
}

.ip-row-last {
  border-bottom: none;
}

.ip-row-label {
  color: #2441a3;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}

.ip-row-value {
  color: #1b2f8f;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}

.ip-row-muted {
  color: #6073a9;
}

/* =========================================================
   STATUS BADGE
========================================================= */

.ip-status-badge {
  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding: 3px 12px;

  border-radius: 12px;

  background: #fdeecf;

  color: #7a5b2a;

  font-size: 10px;

  line-height: 14px;

  font-weight: 400;
}

.ip-status-dot {
  width: 6px;
  height: 6px;

  border-radius: 50%;

  background: #f4a01c;
}

/* =========================================================
   WHAT HAPPENS NEXT
========================================================= */

.ip-next-section {
  width: 100%;

  text-align: center;
}

.ip-next-section h3 {
  margin: 0 0 6px;

  color: #102bc9;

  font-size: 15px;

  line-height: 19px;

  font-weight: 700;
}

.ip-next-section p {
  margin: 0 auto 16px;

  max-width: 420px;

  color: #5f76b8;

  font-size: 10px;

  line-height: 14px;
}

/* =========================================================
   BUTTON
========================================================= */

.ip-button {
  width: 100%;

  height: 34px;

  border: none;

  border-radius: 3px;

  background: #0879ed;

  color: #ffffff;

  font-family: Arial, Helvetica, sans-serif;

  font-size: 12px;

  line-height: 16px;

  font-weight: 700;

  cursor: pointer;

  box-shadow:
    0 2px 5px rgba(0,100,220,0.18);

  transition: background 0.15s ease;
}

.ip-button:hover {
  background: #066bd3;
}

/* =========================================================
   BOTTOM THREE CONTENT ITEMS
========================================================= */

.ip-strip {
  width: 100%;

  margin: 16px 0 0;

  padding: 12px 16px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  border-top: 1px solid #d5e4f6;

  // background: #f5faff;
}

.ip-strip-line {
  width: 1px;

  align-self: stretch;

  background: #d5e4f6;

  margin: 0 12px;
}

.ip-strip-item {
  flex: 1;

  display: flex;

  align-items: flex-start;

  gap: 8px;

  min-width: 0;
}

.ip-strip-icon {
  width: 30px;
  height: 30px;

  flex-shrink: 0;

  border-radius: 50%;

  display: flex;

  align-items: center;
  justify-content: center;

  background: #d9efff;

  color: #126de2;
}

.ip-strip-icon svg {
  width: 17px;
  height: 17px;
}

.ip-strip-text {
  min-width: 0;
}

.ip-strip-title {
  color: #173bb8;

  font-size: 9px;

  line-height: 12px;

  font-weight: 700;

  margin-bottom: 2px;
}

.ip-strip-description {
  color: #6d7fae;

  font-size: 9px;

  line-height: 11px;
}

.ip-strip-description a {
  color: #173bb8;

  text-decoration: underline;
}

/* =========================================================
   TABLET
========================================================= */

@media only screen and (max-width: 768px) {

  .ip-banner {
    height: 105px;
  }

  .ip-banner-content {
    height: 88px;

    padding: 8px 14px;
  }

  .ip-tagline {
    font-size: 15px;
  }

  .ip-card-container {
    width: calc(100% - 20px);

    padding: 20px 16px 24px;

    margin-top: -26px;
  }

  .ip-card {
    max-width: 370px;
  }
}

/* =========================================================
   MOBILE
========================================================= */

@media only screen and (max-width: 480px) {

  .desktop-break {
    display: none;
  }

  .ip-banner {
    height: 88px;
  }

  .ip-banner-content {
    height: 74px;

    padding: 6px 10px;

    gap: 8px;
  }

  .ip-hs-logo {
    width: 58px;
  }

  .ip-thrive-logo {
    width: 80px;
  }

  .ip-brand-divider {
    height: 34px;
  }

  .ip-tagline {
    font-size: 11px;

    line-height: 14px;

    white-space: normal;
  }

  .ip-card-container {
    width: calc(100% - 12px);

    margin-top: -26px;

    padding: 14px 10px 18px;
  }

  .ip-title {
    font-size: 20px;

    line-height: 25px;

    margin-bottom: 14px;
  }

  .ip-card {
    width: 100%;

    padding: 14px 12px 16px;
  }

  .ip-heading {
    font-size: 20px;

    line-height: 24px;
  }

  .ip-text {
    font-size: 10px;

    line-height: 14px;
  }

  .ip-row {
    grid-template-columns: 105px 1fr;
  }

  .ip-strip {
    width: 100%;

    flex-direction: column;

    align-items: stretch;

    gap: 10px;
  }

  .ip-strip-line {
    width: 100%;

    height: 1px;

    margin: 0;
  }
}

`;